import React from 'react';
import { cn } from '@/lib/utils';
import { STATUS_META } from '@/lib/format';

export const StatusBadge = ({ status, className, testid }) => (
  <span
    data-testid={testid}
    className={cn(
      'inline-flex items-center gap-1.5 rounded-md px-2 py-0.5 text-[11px] font-semibold whitespace-nowrap',
      STATUS_META[status] || 'bg-slate-100 text-slate-700 ring-1 ring-inset ring-slate-200',
      className
    )}
  >
    <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
    {status === 'new' ? 'New' : status === 'converted' ? 'Converted' : status === 'dismissed' ? 'Dismissed' : status}
  </span>
);

export const ConfidenceBar = ({ value }) => {
  const pct = Math.round((value || 0) * 100);
  const color = pct >= 80 ? 'bg-money' : pct >= 60 ? 'bg-warn' : 'bg-slate-400';
  return (
    <div className="flex items-center gap-2 min-w-[92px]">
      <div className="h-1.5 w-14 rounded-full bg-slate-200/80 overflow-hidden">
        <div className={cn('h-full rounded-full bar-fill', color)} style={{ width: `${pct}%` }} />
      </div>
      <span className="text-xs font-semibold tabular-nums text-slate-600 num">{pct}%</span>
    </div>
  );
};
